import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { AgencyFilledIcon } from '@gemini/icons';
import { MapPin } from '@gemini/patterns-mappin';
import { LngLat, Marker } from 'mapbox-gl';
import { createPortal } from 'react-dom';
import { MapEvents } from '@/hooks/useMap/useMap';
export const AgencyMapPin = ({ map, agencyPoints }) => {
    const markersRef = useRef([]);
    const features = useMemo(() => agencyPoints?.features ?? [], [agencyPoints]);
    const [selectedMarkerId, setSelectedMarkerId] = useState();
    useEffect(() => {
        if (!map) {
            markersRef.current.forEach((entry) => entry.marker.remove());
            markersRef.current = [];
        }
    }, [map]);
    useEffect(() => {
        if (!map)
            return;
        const newEntries = [];
        features.forEach((feature) => {
            const id = feature.properties?.id;
            const coordinates = feature.geometry?.coordinates;
            if (!id || !coordinates)
                return;
            const existing = markersRef.current.find((entry) => entry.id === id);
            if (existing) {
                newEntries.push(existing);
            }
            else {
                const div = document.createElement('div');
                const marker = new Marker(div).setLngLat(coordinates).addTo(map);
                newEntries.push({ id, marker, div, coordinates });
            }
        });
        markersRef.current.forEach((entry) => {
            const stillExists = newEntries.some((n) => n.id === entry.id);
            if (!stillExists)
                entry.marker.remove();
        });
        markersRef.current = newEntries;
    }, [map, features]);
    return (_jsx(_Fragment, { children: features.map((feature) => {
            const id = feature.properties?.id;
            const coordinates = feature.geometry?.coordinates;
            if (!id || !coordinates)
                return null;
            const entry = markersRef.current.find((e) => e.id === id);
            if (!entry)
                return null;
            return createPortal(_jsx(MapPin, { icon: () => _jsx(AgencyFilledIcon, { size: "sizing.16" }), iconOnly: true, onPress: () => {
                    map?.fire(MapEvents.SHOW_AGENCY_CARD, {
                        agencyId: id,
                        lngLat: new LngLat(coordinates[0], coordinates[1]),
                    });
                    setSelectedMarkerId(entry.id);
                }, isSelected: entry.id === selectedMarkerId, children: "AgencyCard" }, id), entry.div);
        }) }));
};
